import { Dimensions, StyleSheet, Text, View } from "react-native";
import React from "react";
import Animated, {
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import Colors from "../../../constants/Colors";
import GlobalContext from "../../../context/Global";
import Pressable from "../../../components/Pressable";

interface OptionSelectProps {
  index: number;
  selected: number | null;
  setSelected: (index: number) => void;
  option: string;
}
const { width } = Dimensions.get("window");

const OptionSelect: React.FC<OptionSelectProps> = ({
  index,
  selected,
  option,
  setSelected,
}) => {
  const { isTablet } = React.useContext(GlobalContext);

  const offset = useSharedValue(0);

  const animatedTileStyle = useAnimatedStyle(() => {
    return {
      transform: [{ scale: interpolate(offset.value, [0, 1], [1, 0.9]) }],
    };
  });

  const _onPressIn = () => {
    offset.value = withTiming(1, { duration: 140 });
  };

  const _onPressOut = () => {
    offset.value = withTiming(0, { duration: 140 });
  };

  const formatOption = (option: string) => {
    switch (option) {
      case "Buyer":
        return "Buying";
      case "Seller":
        return "Selling";
      case "Both":
        return "Both";
      default:
        return option;
    }
  };

  return (
    <Animated.View style={[animatedTileStyle]}>
      <Pressable
        key={index}
        style={
          isTablet
            ? selected === index
              ? styles.selected
              : styles.option
            : selected === index
            ? styles.phoneSelected
            : styles.phoneOption
        }
        onPressIn={_onPressIn}
        onPressOut={_onPressOut}
        onPress={() => setSelected(index, option)}
      >
        <Text
          style={
            selected === index ? styles.optionTextSelected : styles.optionText
          }
        >
          {formatOption(option)}
        </Text>
      </Pressable>
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  selected: {
    height: 160,
    width: 160,
    borderRadius: 6,
    borderWidth: 2.4,
    backgroundColor: Colors.primary_500,
    borderColor: Colors.primary_500,
    justifyContent: "center",
    alignItems: "center",
    margin: 16,
  },
  phoneSelected: {
    height: 75,
    width: width - 60,
    maxWidth: 500,
    borderRadius: 6,
    backgroundColor: Colors.primary_500,
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: 20,
    marginVertical: 8,
  },
  optionText: {
    fontSize: 24,
    color: Colors.nuetral_grey_700,
    fontFamily: "NunitoSemiBold",
  },
  optionTextSelected: {
    fontSize: 24,
    color: "white",
    fontFamily: "NunitoBold",
  },
  option: {
    height: 160,
    width: 160,
    borderRadius: 6,
    borderWidth: 2.4,
    borderColor: Colors.nuetral_grey_400,
    justifyContent: "center",
    alignItems: "center",
    margin: 16,
  },
  phoneOption: {
    height: 75,
    width: width - 60,
    maxWidth: 500,
    borderRadius: 6,
    backgroundColor: Colors.nuetral_grey_100,
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: 20,
    marginVertical: 8,
  },
});

export default OptionSelect;
